<template>
    <div class="c-reservation-product">
        <input type="hidden" name="product_id" :value="product.id">

        <div class="c-reservation-product__img">
            <img class="c-img" :src="thumbnail(product.image, 'sm')" :alt="product.name" />

            <div class="c-reservation-product__count">
                {{ selectedQuantity }}x
            </div>
        </div>

        <div class="c-reservation-product__info">
            <div class="c-reservation-product__category">
                {{ product.category.name }}
            </div>

            <div class="c-reservation-product__name">
                {{ product.name }}
            </div>

            <div class="c-reservation-product__price">
                <span class="sc-price">{{ productPrice }}</span>
                <span class="sc-vat-info">{{ $t(pricesWithVat ? 'withVat' : 'withoutVat') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { thumbnail } from 'Functions/thumbnail'
import { formatPrice } from "FrontendJsAssets/common/format"

export default {
    data() {
        return {
            pricesWithVat: window.Eshop.options.pricesWithVat
        }
    },
    methods: {
        thumbnail: thumbnail,
        formatPrice: formatPrice
    },
    computed: {
        ...mapState([
            'product',
            'selectedQuantity',
        ]),
        productPrice() {
            if (this.pricesWithVat) {
                return this.formatPrice(this.product.price_vat)
            }

            return this.formatPrice(this.product.price)
        }
    }
}
</script>